import { useState, Fragment } from "react";
import BTDialogBox from "../../components/BTDialgBox/index.js";
import EnhancedTable from "../../components/BTTable/index.js";
import BTInput from "../../components/BTInput/index.js";
import Report from "./reports/index1.js";
import { CircularProgress } from "@mui/material";
import { pdf } from "@react-pdf/renderer";
import authService from "../../services/auth-service.js";
import { useNotification } from "../../context/index.js";
import { Error, Notifications } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { batchUpdate } from "../../store/labSlice.js";
const Varificationsummary = ({
  varificationSummary,
  setVarificationSummary,
  todayRate,
  sizes,
  setReturnsData,
  setRefresh,
}) => {
  const { row, returns_data } = varificationSummary;
  const dispatch = useDispatch();
  const [summaryData, setSummaryData] = useState(row);
  const [loading, setLoading] = useState(false);
  const { addNotification } = useNotification();
  const handleClose = () => {
    setVarificationSummary(null);
  };
  const handleTableFieldChange = (name, value, index, row) => {
    const newsummaryData = [...summaryData?.sub_billing_lines];
    if (name === "bill_rate") {
      newsummaryData[index][name] = value;
      if (row.ser_price_type === 3) {
        newsummaryData[index].bill_amount = row.bill_cts * Number(value);
      } else {
        newsummaryData[index].bill_amount = row.bill_pcs * Number(value);
      }
      newsummaryData[index].bill_total =
        newsummaryData[index].bill_amount * todayRate;
    }
    setSummaryData((item) => ({
      ...item,
      bill_total: newsummaryData?.reduce(
        (total, item) => total + Number(item?.bill_total),
        0
      ),
      bill_amount: newsummaryData.reduce(
        (total, item) => total + item.bill_amount,
        0
      ),
      sub_billing_lines: newsummaryData,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const finalFormData = {
      ...summaryData,
      bill_status: 1,
      bill_total: summaryData?.sub_billing_lines?.reduce(
        (total, item) => total + Number(item?.bill_total),
        0
      ),
      bill_amount: summaryData?.sub_billing_lines.reduce(
        (total, item) => total + item.bill_amount,
        0
      ),
      sub_billing_lines: summaryData?.sub_billing_lines?.map((item) => ({
        ...item,
        bill_status: 1,
      })),
      returns: returns_data?.map((item) => ({
        ...item,
        ret_bill_status:
          item?.ret_bill_status === 1 ? 2 : item?.ret_bill_status,
      })),
    };

    try {
      setLoading(true);
      const response = await authService?.insert_bill({
        attributes: finalFormData,
      });
      if (response?.status) {
        const { submits, returns, sub_billing_lines, ...data } = response?.data;
        dispatch(
          batchUpdate({
            name: "submission",
            key: "stn_id",
            insert: [],
            updateItems: submits,
            removeItems: [],
          })
        );
        dispatch(
          batchUpdate({
            name: "return",
            key: "ret_id",
            insert: [],
            updateItems: returns,
            removeItems: [],
          })
        );
        addNotification({
          title: "Successfully",
          message: response?.message,
          type: "success",
          color: "success",
          icon: <Notifications fontSize="small" color="white" />,
        });
        setReturnsData((prev) => {
          return prev?.map((row) => {
            const returnData = response?.data?.returns?.find(
              (item) => item?.ret_id === row?.ret_id
            );
            return returnData || row;
          });
        });
        handleClose();
      }
    } catch (error) {
      addNotification({
        title: "#Error",
        message: error?.message || "Something went wrong",
        type: "error",
        color: "error",
        icon: <Error fontSize="small" color="white" />,
      });
    } finally {
      setLoading(false);
    }
  };
  const handleDownloadPDF = async () => {
    const blob = await pdf(
      <Report data={summaryData} sizes={sizes?.data} />
    ).toBlob();
    const url = URL.createObjectURL(blob);
    const newTab = window.open(url, "_blank");
    newTab.document.close();
    newTab.onbeforeunload = () => {
      URL.revokeObjectURL(url);
    };
  };
  const columns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      width: "50px",
    },
    {
      id: "service",
      name: "service",
      selector: (row) => row.ser_name,
      bodyCellStyle: {
        padding: "0px",
      },
    },
    {
      id: "size",
      name: "size",
      selector: (row) => {
        if (!row.size_id) return "-";
        else {
          const size = sizes?.data?.find(
            ({ size_id }) => size_id === row?.size_id
          );
          return `${size?.size_from} - ${size?.size_to}`;
        }
      },
    },
    {
      id: "pcs",
      name: "Pcs",
      selector: (row) => row.bill_pcs,
      bodyCellStyle: {
        padding: "0px",
      },
    },
    {
      id: "weight",
      name: "Weight",
      selector: (row) => row.bill_cts.toFixed(2),
      bodyCellStyle: {
        padding: "0px",
      },
    },
    {
      id: "rate",
      name: "Rate",
      selector: (row, index) => {
        return (
          <BTInput
            value={row?.bill_rate}
            variant="standard"
            onChange={(e) =>
              handleTableFieldChange("bill_rate", e.target.value, index, row)
            }
            sx={{
              position: "relative",
              top: "1px",
            }}
            type="number"
          />
        );
      },
      bodyCellStyle: {
        padding: "0px",
      },
    },
    {
      id: "amount",
      name: "Amount",
      selector: (row) => Number(row?.bill_amount)?.toFixed(2),
      bodyCellStyle: {
        padding: "0px",
      },
    },
    {
      id: "total",
      name: "Total",
      selector: (row) => Number(row?.bill_total)?.toFixed(2),
      bodyCellStyle: {
        padding: "0px",
      },
    },
  ];
  const compactStyles = {
    headerCellStyle: {
      padding: "5px",
      fontSize: "12px",
    },
    bodyCellStyle: {
      padding: "5px",
      fontSize: "12px",
    },
    headerRowStyle: {
      height: "20px",
    },
    bodyRowStyle: {
      height: "20px",
    },
  };

  return (
    <BTDialogBox
      open={Boolean(varificationSummary)}
      fullWidth
      maxWidth={"xl"}
      maxHeight={"500px"}
      minHeight={"500px"}
      onSubmit={handleSubmit}
      close={handleClose}
      title={"Bill"}
      buttons={[
        {
          name: "Cancel",
          color: "secondary",
          size: "small",
          onClick: handleClose,
        },
        {
          name: "Print",
          color: "dark",
          size: "small",
          onClick: handleDownloadPDF,
        },
        {
          name: "Submit",
          variant: "gradient",
          type: "submit",
          color: "dark",
          size: "small",
          loading: loading,
          loadingComponent: (
            <Fragment>
              <svg width={0} height={0}>
                <defs>
                  <linearGradient
                    id="my_gradient"
                    x1="0%"
                    y1="0%"
                    x2="0%"
                    y2="100%">
                    <stop offset="0%" stopColor="#e01cd5" />
                    <stop offset="100%" stopColor="#1CB5E0" />
                  </linearGradient>
                </defs>
              </svg>
              <CircularProgress
                size={22}
                sx={{
                  "svg circle": { stroke: "url(#my_gradient)" },
                }}
              />
            </Fragment>
          ),
          sx: { ml: 2, width: "80px" },
          disabled: loading,
        },
      ]}>
      <EnhancedTable
        columns={columns}
        rows={summaryData?.sub_billing_lines}
        tableHeader={false}
        compactStyles={compactStyles}
      />
    </BTDialogBox>
  );
};
export default Varificationsummary;
